// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import AlertCircleFill from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleFill";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import CheckmarkCircle2Fill from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import InfoFill from "@store/Library/Components/Toolkit/Icons/Info/InfoFill";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import AlertError from "@store/Library/Components/Icons/AlertError";
/* Store Custom Code - End */

const toast: Styleguide["toast"] = {
    defaultProps: {
        iconSrcByMessage: {
            info: InfoFill,
            warning: AlertTriangleFill,
            danger: AlertError, // Store Custom Code
            success: CheckmarkCircle2Fill,
        },
        iconProps: {
            css: css`
                ${breakpointValues(pxToRemArray([34, null, 40]).map(x => (x ? iconScalableStyles(x) : null)))}
            `,
        },
        bodyTypographyProps: {
            css: css`
                margin-left: 0.625em;

                ${({ theme }) =>
                    breakpointValues(
                        [theme.design.typography.size.smaller, null, theme.design.typography.size.base],
                        "font-size",
                    )}
            `,
        },
        closeButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${focusUpdateStyles(true)}
                display: flex;
                position: absolute;
                top: 0;
                right: 0;
                padding: 0.75em;
                transition: ${transitionHoverStyles("color")};

                &:hover {
                    color: ${getColor("primary")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 14,
            color: "inherit",
        },
        cssOverrides: {
            toast: css`
                box-shadow: ${x => x.theme.shadows.e60};
            `,
        },
    },
};

export default toast;
